export class TokenInvalidoError extends Error {
  constructor(serverMessage) {
    super(serverMessage || 'El enlace no es válido o ha expirado.');
    this.name = 'TokenInvalidoError';
  }
}
